export const TabMixins = {
  handleDuplicate(listItems) {
    const newList = [];
    listItems.forEach((item1) => {
      if (!newList.filter((item2) => item1.label === item2.label).length) {
        newList.push(item1);
      }
    });
    return newList;
  }
};
